import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

// --- COMPONENTS ---
import Navbar from "../../components/Index/Navbar";
import Footer from "../../components/Index/Footer";
import HeroSection from "../../components/Private Class/HeroSection-private";

const KursusPrivate: React.FC = () => {
  // --- Effects ---
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="text-gray-800 font-poppins relative bg-[#f9fafb] overflow-x-hidden w-full">
      {/* Global Fonts & Styles */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');
        html, body { font-family: 'Poppins', sans-serif; overflow-x: hidden; background-color: #f9fafb; width: 100%; position: relative; }
      `}</style>
      {/* ========== NAVBAR ========== */}
      <div className="relative z-50">
        <Navbar />
      </div>{" "}
      {/* ========== HERO SECTION ========== */}
      <HeroSection />
      {/* ========== FOOTER ========== */}
      <Footer />
    </div>
  );
};

export default KursusPrivate;
